<template>
  <div class="headerShortcutMenuContainer">
    <div class="headerShortcutMenuRow">
      <template v-for="(menuItem, index) in menuItems">
        <button
          v-if="isShortcutDisplayed(menuItem)"
          :key="index"
          class="headerShortcutMenuButton"
          :disabled="isDisabled"
          @click="sendMessage(menuItem)">
          {{ menuItem.mainContent }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { sendMessage, trackMenuEvent, shouldDisplayShortcut } from '../lib/chipMessage'
import config from '../config/'

// Dependencies
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderShortcutMenu',
  props: {
    menuItems: { type: Array, required: true },
    isKiosk: { type: Boolean, required: true },
    assistantId: { type: String, required: true },
    isDisabled: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters({
      webchatSlots: 'webchatSlots',
      locale: 'locale'
    })
  },
  methods: {
    isShortcutDisplayed(menuItem) {
      return shouldDisplayShortcut(menuItem, this.webchatSlots, this.locale)
    },
    sendMessage(menuItem) {
      if (this.isDisabled) {
        return
      }
      const mainContent = menuItem.shortcutMessageContent || menuItem.mainContent
      sendMessage(
        this.$store,
        menuItem.payload,
        mainContent,
        config.SOURCE_TYPES.MENU,
        this.assistantId,
        this.$t('location_permission_error'),
        config.EVENT_ELEMENTS.MENU_LINK,
        this.isKiosk
      )
      if (!menuItem.payload || !menuItem.payload.url) {
        trackMenuEvent(this.$store, config.EVENT_TYPES.CLICK, config.INPUT_TYPES.TOUCH, mainContent)
      }
    }
  }
}
</script>

<style>
.headerShortcutMenuContainer {
  max-width: 60%;
  align-self: stretch;
  display: flex;
  align-items: center;
}

.headerShortcutMenuRow {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  width: 100%;
  align-content: center;
}

.headerShortcutMenuButton {
  background-color: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 0.25rem;
  padding: 0.4rem 0.75rem;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
  white-space: nowrap;
}

.headerShortcutMenuButton:hover:not(:disabled) {
  background-color: rgba(255, 255, 255, 0.15);
}

.headerShortcutMenuButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
